var map = {
	"./avatar.png": 26,
	"./cowboy-cafe.png": 43,
	"./daily-web-app.png": 44,
	"./react-logo.png": 45,
	"./steam-library-unlock.png": 46,
	"./taskmanager-560-groups.png": 47,
	"./taskmanager560-dashboard.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;